module.exports = __webpack_public_path__ + "static/media/listing page card type A with tatkal.33ef73dd.png";